import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePipe } from '@angular/common';
import { emptyOrderAdminKpis, OrderAdminKpisDto, OrderAdminQuery, OrderService } from '../../../../core/services/order.service';
import {
  PackingPrintService,
  PackingPerPage,
  PackingPrintFilter,
  PACKING_PER_PAGE_OPTIONS,
  PACKING_STATUS_OPTIONS,
  guiaImpresaQuery
} from '../../../../core/services/packing-print.service';
import { TipoEnvioService } from '../../../../core/services/tipo-envio.service';
import { Order } from '../../../../shared/models/Order';
import { ImageModule } from 'primeng/image';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';

import { ImgUrlPipe } from '../../../../shared/pipes/img-url.pipe';
import { PeruDatePipe } from '../../../../shared/pipes/peru-date.pipe';
import { MpPaymentPanel } from '../../../../shared/components/mp-payment-panel/mp-payment-panel';
import { formatMoananiDateTimeExport } from '../../../../core/utils/peru-datetime';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { exportJsonToExcel } from '../../../../core/utils/excel-export';
import { BoletaService, OrderBoletaStatus } from '../../../../core/services/boleta.service';
import {
  AdminExportBundle,
  boletaMapFromOrders,
  boletaStatusFromOrder,
  isTerminalOrderStatus,
  loadAdminExport,
  mergeOrderRow,
  orderIdsWithoutBoletaFlag
} from '../../../../core/utils/admin-order-page';
import {
  getBoletaExportLabel,
  getOrderAmountPaid,
  getOrderDeliveryPrice,
  getOrderProductLabel,
  getOrderTotalAmount,
  money
} from '../../../../core/utils/order-export';

@Component({
  selector: 'app-delivery-management',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, ButtonModule,
    ToastModule, TagModule, TooltipModule, SelectModule, ImageModule, DialogModule, DatePickerModule, ImgUrlPipe, ConfirmDialogModule, PeruDatePipe, MpPaymentPanel
  ],
  providers: [MessageService, DatePipe, ConfirmationService],
  templateUrl: './delivery-management.html',
  styleUrls: ['./delivery-management.css']
})
export class DeliveryManagementComponent implements OnInit {

  pageOrders: Order[] = [];
  filteredOrders: Order[] = [];
  selectedOrders: Order[] = [];
  tipoEnvioFilterId: number | null = null;
  tipoEnvioFilterOptions: { label: string; value: number | null }[] = [{ label: 'Todos', value: null }];
  first = 0;
  rows = 10;
  totalRecords = 0;
  editingStatusId: number | null = null;
  packingPerPage: PackingPerPage = 1;
  packingPrintFilter: PackingPrintFilter = '';
  packingPerPageOptions = PACKING_PER_PAGE_OPTIONS;
  packingStatusOptions = PACKING_STATUS_OPTIONS;
  loading: boolean = true;
  exporting: 'excel' | 'pdf' | null = null;
  private listRequest = 0;
  detailsDialog: boolean = false;
  selectedOrder: any = null;
  tempDate: Date | null = null;
  tempTime: Date | null = null;
  boletaStatusMap: Record<number, OrderBoletaStatus> = {};
  private kpis: OrderAdminKpisDto = emptyOrderAdminKpis();
  private kpiRequest = 0;

  get totalAdelantado(): number {
    return this.kpis.totalAdelantado;
  }

  get totalNetoCobrado(): number {
    return this.kpis.netoCobrado;
  }

  get totalComisionesMp(): number {
    return this.kpis.comisionesMp;
  }

  get totalEnvioInfo(): number {
    return this.kpis.totalEnvioAdelantado;
  }

  get totalVentas(): number {
    return this.kpis.totalVentas;
  }

  get totalPagoPendiente(): number {
    return this.kpis.totalPagoPendiente;
  }

  deliveryStatuses = [
    {label: 'Confirmado', value: 'CONFIRMADO'},
    {label: 'En Preparación', value: 'EN_PREPARACION'},
    {label: 'En Ruta', value: 'EN_RUTA'},
    {label: 'Entregado', value: 'ENTREGADO'}
  ];

  pickupStatuses = [
    {label: 'Confirmado', value: 'CONFIRMADO'},
    {label: 'En Preparación', value: 'EN_PREPARACION'},
    {label: 'Listo para Recojo', value: 'LISTO_RECOJO'},
    {label: 'Entregado', value: 'ENTREGADO'}
  ];

  constructor(
    private orderService: OrderService,
    private packingPrint: PackingPrintService,
    private tipoEnvioService: TipoEnvioService,
    private boletaService: BoletaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.loadKpis();
    this.tipoEnvioService.getActive().subscribe({
      next: (list) => {
        this.tipoEnvioFilterOptions = [
          { label: 'Todos', value: null },
          ...list.map(t => ({ label: t.nombreTipoEnvio, value: t.id }))
        ];
        this.cdr.detectChanges();
      },
      error: () => {}
    });
  }

  statusOptions(order: Order) {
    if (order.deliveryMethod === 'PUNTO' || order.deliveryMethod === 'RECOJO_PUNTO') return this.pickupStatuses;
    return this.deliveryStatuses;
  }

  openDetails(order: any) {
    this.selectedOrder = order;
    this.detailsDialog = true;
    this.tempDate = null;
    this.tempTime = null;

    if (order.scheduledDate) {
      this.tempDate = new Date(order.scheduledDate + 'T00:00:00');
    }
    if (order.scheduledTime) {
      const d = new Date();
      const [hours, minutes] = order.scheduledTime.split(':');
      d.setHours(+hours);
      d.setMinutes(+minutes);
      this.tempTime = d;
    }
  }

  reloadFirst(): void {
    this.first = 0;
    this.loadKpis();
    this.loadOrders({ first: 0, rows: this.rows });
  }

  private listFilters(): OrderAdminQuery {
    return {
      canal: 'WEB',
      isManualSale: false,
      vista: 'ACTIVOS',
      tipoEnvioId: this.tipoEnvioFilterId ?? undefined,
      guiaImpresa: guiaImpresaQuery(this.packingPrintFilter)
    };
  }

  loadKpis(): void {
    const request = ++this.kpiRequest;
    this.orderService.getAdminKpis(this.listFilters()).subscribe({
      next: (kpis) => {
        if (request !== this.kpiRequest) return;
        this.kpis = kpis;
        this.cdr.detectChanges();
      },
      error: () => {
        if (request !== this.kpiRequest) return;
        this.kpis = emptyOrderAdminKpis();
        this.cdr.detectChanges();
      }
    });
  }

  loadOrders(event?: TableLazyLoadEvent) {
    if (!event) this.loadKpis();
    const request = ++this.listRequest;
    this.loading = true;
    const first = event?.first ?? this.first;
    const rows = event?.rows || this.rows;
    this.first = first || 0;
    this.rows = rows;
    const page = this.rows > 0 ? Math.floor(this.first / this.rows) : 0;
    this.orderService.getAdminOrders({
      ...this.listFilters(),
      page,
      size: this.rows
    }).subscribe({
      next: (res) => {
        if (request !== this.listRequest) return;
        this.pageOrders = res.content || [];
        this.filteredOrders = this.pageOrders;
        this.totalRecords = res.totalElements || 0;
        this.selectedOrders = [];
        this.loading = false;
        this.syncBoletas(this.pageOrders);
        this.cdr.detectChanges();
      },
      error: () => {
        if (request !== this.listRequest) return;
        this.loading = false;
        this.pageOrders = [];
        this.filteredOrders = [];
        this.totalRecords = 0;
        this.messageService.add({severity:'error', summary:'Error', detail:'No se pudieron cargar los pedidos'});
        this.cdr.detectChanges();
      }
    });
  }

  private syncBoletas(orders: Order[]): void {
    this.boletaStatusMap = boletaMapFromOrders(orders);
    const missing = orderIdsWithoutBoletaFlag(orders);
    this.cdr.detectChanges();
    if (!missing.length) return;
    this.boletaService.estadosOrdenes(missing).subscribe({
      next: (rows) => {
        rows.forEach(r => { this.boletaStatusMap[r.orderId] = r; });
        this.cdr.detectChanges();
      },
      error: () => { this.boletaStatusMap = { ...this.boletaStatusMap }; }
    });
  }

  printOne(order: Order): void {
    this.printPackingSlips([order]);
  }

  printSelected(): void {
    this.printPackingSlips(this.selectedOrders || []);
  }

  printLastThree(): void {
    this.printPackingSlips(this.filteredOrders.slice(0, 3));
  }

  private printPackingSlips(orders: Order[]): void {
    this.packingPrint.printAndMark(orders, this.packingPerPage).subscribe({
      next: () => {
        this.applyGuiaPrinted();
        this.messageService.add({
          severity: 'success',
          summary: 'Hoja de empaque',
          detail: `${orders.length} pedido(s) listos para meter en la caja.`
        });
      },
      error: (err) => {
        if (err?.code === 'EMPTY') {
          this.messageService.add({ severity: 'warn', summary: 'Impresión', detail: 'Selecciona al menos un pedido.' });
          return;
        }
        if (err?.code === 'POPUP') {
          this.messageService.add({
            severity: 'warn',
            summary: 'Ventana bloqueada',
            detail: 'Permite ventanas emergentes e inténtalo de nuevo. No se marcó como impresa.'
          });
          return;
        }
        this.messageService.add({
          severity: 'warn',
          summary: 'Impresión',
          detail: 'Se abrió la impresión, pero no se pudo guardar el estado. Vuelve a intentar.'
        });
      }
    });
  }

  private applyGuiaPrinted(): void {
    this.loadKpis();
    this.loadOrders({ first: this.first, rows: this.rows });
  }

  private applyUpdated(updated: Order): void {
    const drop = isTerminalOrderStatus(updated.status);
    const result = mergeOrderRow(this.pageOrders, updated, drop);
    this.pageOrders = result.rows;
    if (result.removed) this.totalRecords = Math.max(0, this.totalRecords - 1);
    this.selectedOrders = drop
      ? this.selectedOrders.filter(order => order.id !== updated.id)
      : this.selectedOrders.map(order => order.id === updated.id ? { ...order, ...updated } : order);
    if (this.selectedOrder?.id === updated.id) {
      this.selectedOrder = drop ? null : { ...this.selectedOrder, ...updated };
      if (drop) this.detailsDialog = false;
    }
    const flag = boletaStatusFromOrder(updated);
    if (drop) delete this.boletaStatusMap[updated.id];
    else if (flag) this.boletaStatusMap[updated.id] = flag;
    this.editingStatusId = null;
    this.filteredOrders = this.pageOrders;
    this.cdr.detectChanges();
  }

  updateStatus(order: Order, newStatus: string) {
    if (newStatus === 'ENTREGADO') {
      this.confirmationService.confirm({
        message: '¿Estás seguro de marcar este pedido como ENTREGADO? Esta acción finalizará el proceso.',
        header: 'Confirmar Entrega',
        icon: 'pi pi-exclamation-triangle',
        acceptButtonStyleClass: 'p-button-success',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Sí',      
        rejectLabel: 'No',
        accept: () => {
          this.executeStatusUpdate(order, newStatus);
        },
        reject: () => {
          this.editingStatusId = null;
          this.cdr.detectChanges();
        }
      });
    } else {
      this.executeStatusUpdate(order, newStatus);
    }
  }

  executeStatusUpdate(order: Order, newStatus: string) {
    this.orderService.updateStatus(order.id, newStatus).subscribe({
      next: (updated) => {
        this.messageService.add({severity:'success', summary:'Actualizado', detail:`Pedido #${order.id} ahora está: ${updated.status || newStatus}`});
        this.applyUpdated(updated?.id ? updated : { ...order, status: newStatus });
        this.loadKpis();
      },
      error: (err) => {
        console.error(err);
        this.editingStatusId = null;
        this.messageService.add({severity:'error', summary:'Error', detail:'No se pudo actualizar el estado'});
        this.loadOrders({ first: this.first, rows: this.rows });
      }
    });
  }

  saveSchedule() {
    if (!this.selectedOrder || !this.tempDate || !this.tempTime) return;

    const dateStr = this.datePipe.transform(this.tempDate, 'yyyy-MM-dd') || '';
    const timeStr = this.datePipe.transform(this.tempTime, 'HH:mm') || '';

    this.orderService.updateSchedule(this.selectedOrder.id, dateStr, timeStr).subscribe({
      next: (res) => {
        this.messageService.add({severity:'success', summary:'Agendado', detail:'Fecha y hora actualizadas'});
        this.selectedOrder.scheduledDate = dateStr;
        this.selectedOrder.scheduledTime = timeStr + ':00';
        const result = mergeOrderRow(this.pageOrders, {
          ...this.selectedOrder,
          scheduledDate: dateStr,
          scheduledTime: timeStr + ':00'
        }, false);
        this.pageOrders = result.rows;
        this.filteredOrders = this.pageOrders;
        this.detailsDialog = false;
        this.cdr.detectChanges();
      },
      error: (err) => this.messageService.add({severity:'error', summary:'Error', detail:'No se pudo agendar'})
    });
  }

  getSeverity(status: string): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined {
    switch(status) {
      case 'CONFIRMADO': return 'info';
      case 'EN_PREPARACION': return 'warn';
      case 'EN_RUTA': return 'secondary';
      case 'LISTO_RECOJO': return 'secondary';
      case 'ENTREGADO': return 'success';
      default: return 'secondary';
    }
  }

  /** Etiqueta de estado de pago: ADELANTO/ADELANTO_50 se muestran como "Pago pendiente" por política de negocio. */
  getPaymentStatusLabel(paymentStatus: string | undefined): string {
    if (!paymentStatus) return 'Pago pendiente';
    const s = (paymentStatus || '').toUpperCase();
    if (s === 'ADELANTO' || s === 'ADELANTO_50' || s === 'PENDIENTE_PAGO') return 'Pago pendiente';
    if (s === 'PAGO_COMPLETO' || s === 'PAGADO_COMPLETO') return 'Pago completo';
    return 'Pago pendiente';
  }

  getPaymentSeverity(paymentStatus: string | undefined): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined {
    const s = (paymentStatus || '').toUpperCase();
    if (s === 'PAGO_COMPLETO' || s === 'PAGADO_COMPLETO') return 'success';
    return 'warn';
  }

  /** Fecha y hora en hora local, formato 24h para que Excel no cambie día/hora por zona horaria o AM/PM */
  private formatDateTimeExport(isoStr: string): string {
    return formatMoananiDateTimeExport(isoStr || '');
  }

  /** Fecha solo (YYYY-MM-DD) como dd/MM/yyyy sin usar UTC para evitar desfase de un día en Excel */
  private formatDateOnlyExport(dateStr: string, timeStr?: string): string {
    if (!dateStr) return '';
    const part = dateStr.split('T')[0];
    const [y, m, d] = part.split('-');
    if (!y || !m || !d) return dateStr;
    const formatted = `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
    return timeStr ? `${formatted} ${timeStr}` : formatted;
  }

  exportExcel(): void {
    this.runExport('excel', ({ rows, kpis, boletas }) => {
      const exportData = rows.map(o => ({
        'Fecha registro': this.formatDateTimeExport(o.createdAt || ''),
        'N° Orden': o.id,
        'Fecha entrega': this.formatDateOnlyExport(o.scheduledDate || '', o.scheduledTime || undefined),
        Cliente: o.clientName,
        Producto: getOrderProductLabel(o),
        'Tipo de Envío': o.tipoEnvio?.nombreTipoEnvio || o.deliveryMethod || '',
        Destino: (o.distrito?.nombre || o.district || '') + (o.deliveryAddress ? ' - ' + o.deliveryAddress : ''),
        Estado: o.status,
        Envío: getOrderDeliveryPrice(o),
        Adelanto: getOrderAmountPaid(o),
        'Total venta': getOrderTotalAmount(o),
        Boleta: getBoletaExportLabel(o.id, boletas)
      }));
      exportData.push({} as any);
      exportData.push({
        Cliente: 'RESUMEN',
        Envío: kpis.totalEnvioAdelantado,
        Adelanto: kpis.totalAdelantado,
        'Total venta': kpis.totalVentas,
        Boleta: 'Envío informativo; cobrado = suma de adelantos'
      } as any);
      return exportJsonToExcel(
        exportData,
        `gestion_entregas_${new Date().getTime()}.xlsx`
      );
    });
  }

  exportPdf(): void {
    this.runExport('pdf', ({ rows, kpis, boletas }) => {
      const doc = new jsPDF({ orientation: 'landscape' });
      doc.setFontSize(16);
      doc.text('Reporte de Gestión de Entregas', 14, 20);
      doc.setFontSize(10);
      doc.text(`Generado: ${new Date().toLocaleDateString()} - Pedidos en logística`, 14, 28);
      const head = [['N°', 'Cliente', 'Producto', 'Tipo Envío', 'Estado', 'Envío', 'Adelanto', 'Total venta', 'Boleta']];
      const body = rows.map(o => [
        o.id,
        o.clientName || '',
        getOrderProductLabel(o),
        o.tipoEnvio?.nombreTipoEnvio || o.deliveryMethod || '',
        o.status || '',
        money(getOrderDeliveryPrice(o)),
        money(getOrderAmountPaid(o)),
        money(getOrderTotalAmount(o)),
        getBoletaExportLabel(o.id, boletas)
      ]);
      autoTable(doc, {
        startY: 35,
        head,
        body,
        theme: 'grid',
        headStyles: { fillColor: [0, 0, 0] },
        styles: { fontSize: 7 },
        columnStyles: { 2: { cellWidth: 40 }, 8: { cellWidth: 36 } }
      });
      const finalY = (doc as any).lastAutoTable.finalY + 10;
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text(`Total cobrado (adelantos): ${money(kpis.totalAdelantado)}`, 14, finalY);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`Pendiente: ${money(kpis.totalPagoPendiente)}  |  Envío (informativo): ${money(kpis.totalEnvioAdelantado)}`, 14, finalY + 7);
      doc.save('gestion_entregas.pdf');
    });
  }

  private runExport(
    kind: 'excel' | 'pdf',
    consume: (bundle: AdminExportBundle) => Promise<void> | void
  ): void {
    if (this.exporting) return;
    const summary = kind === 'excel' ? 'Excel' : 'PDF';
    this.exporting = kind;
    this.cdr.detectChanges();
    loadAdminExport(this.orderService, this.boletaService, this.listFilters()).subscribe({
      next: (bundle) => {
        if (!bundle.rows.length) {
          this.exporting = null;
          this.messageService.add({ severity: 'warn', summary, detail: 'No hay pedidos para exportar' });
          this.cdr.detectChanges();
          return;
        }
        Promise.resolve()
          .then(() => consume(bundle))
          .catch((e: Error) => this.messageService.add({
            severity: 'warn',
            summary,
            detail: e?.message || 'No se pudo exportar'
          }))
          .finally(() => {
            this.exporting = null;
            this.cdr.detectChanges();
          });
      },
      error: () => {
        this.exporting = null;
        this.messageService.add({ severity: 'error', summary, detail: 'No se pudo exportar' });
        this.cdr.detectChanges();
      }
    });
  }
}